import { BaseAPI } from '@/lib/api';

export interface HistoryItem {
  id: string;
  query: string;
  created_at_str: string;
  results_count: number;
  is_api: boolean;
}

export interface HistoryResponse {
  ok?: boolean;
  data?: HistoryItem[];
  error?: string;
}

class HistoryAPI extends BaseAPI {
  // Получение истории поиска
  async getSearchHistory(): Promise<HistoryItem[] | HistoryResponse> {
    return this.makeRequest<HistoryItem[] | HistoryResponse>('/api/search_history');
  }
}

export const historyAPI = new HistoryAPI();
